import { OrganizationDto } from "../app/model/api/types/dto/organizationDto";
import { FileViewModel } from "./fileViewModel";

export class OrganizationViewModel {
  id?: string | null;
  name: string | null;
  description: string | null;
  addressLine1: string | null;
  addressLine2: string | null;
  city: string | null;
  stateId: Array<string> | null;
  zipCode: string | null;
  mainPhone: string | null;
  fax: string | null;
  websiteUrl: string | null;
  payrollDeductionFrequencyId: string | null;
  isActive: boolean | null;
  sortValue: number | null;
  logo: FileViewModel | null;
  contactName: string | null;
  contactPhone: string | null;
  contactEmail: string | null;

  constructor(
    id: string | null,
    name: string | null,
    description: string | null,
    addressLine1: string | null,
    addressLine2: string | null,
    city: string | null,
    stateId: Array<string> | null,
    zipCode: string | null,
    mainPhone: string | null,
    fax: string | null,
    websiteUrl: string | null,
    payrollDeductionFrequencyId: string | null,
    isActive: boolean | null,
    sortValue: number | null,
    logo: FileViewModel | null,
    contactName: string | null,
    contactPhone: string | null,
    contactEmail: string | null
  ) {
    this.id = id;
    this.name = name;
    this.description = description;
    this.addressLine1 = addressLine1;
    this.addressLine2 = addressLine2;
    this.city = city;
    this.stateId = stateId;
    this.zipCode = zipCode;
    this.mainPhone = mainPhone;
    this.fax = fax;
    this.websiteUrl = websiteUrl;
    this.payrollDeductionFrequencyId = payrollDeductionFrequencyId;
    this.isActive = isActive;
    this.sortValue = sortValue;
    this.logo = logo;
    this.contactName=contactName;
    this.contactPhone=contactPhone;
    this.contactEmail=contactEmail;
  }

  toDto(): OrganizationDto {
    return {
      id: this.id,
      name: this.name,
      description: this.description,
      addressLine1: this.addressLine1,
      addressLine2: this.addressLine2,
      city: this.city,
      stateId:
        this.stateId !== null && this.stateId?.length > 0
          ? this.stateId[0]
          : null,
      zipCode: this.zipCode,
      mainPhone: this.mainPhone,
      fax: this.fax,
      websiteUrl: this.websiteUrl,
      payrollDeductionFrequencyId: this.payrollDeductionFrequencyId,
      isActive: this.isActive,
      sortValue: this.sortValue,
      logo: this.logo
        ? new FileViewModel(
            this.logo.id,
            this.logo.fileName,
            this.logo.mimeType,
            this.logo.content
          ).toDto()
        : null,
        contactName: this.contactName,
        contactPhone: this.contactPhone,
        contactEmail: this.contactEmail,

    };
  }

  mapFromDto(dto: OrganizationDto): void {
    this.id = dto.id;
    this.name = dto.name;
    this.description = dto.description;
    this.addressLine1 = dto.addressLine1;
    this.addressLine2 = dto.addressLine2;
    this.city = dto.city;
    dto.stateId !== null
      ? this.stateId?.push(dto.stateId)
      : (this.stateId = null);
    this.zipCode = dto.zipCode;
    this.mainPhone = dto.mainPhone;
    this.fax = dto.fax;
    this.websiteUrl = dto.websiteUrl;
    this.payrollDeductionFrequencyId = dto.payrollDeductionFrequencyId;
    this.isActive = dto.isActive !== undefined ? dto.isActive : null;
    this.sortValue = dto.sortValue;
    this.logo = dto.logo ? FileViewModel.mapFromDto(dto.logo) : null;
    this.contactName = dto.contactName;
    this.contactPhone = dto.contactPhone;
    this.contactEmail = dto.contactEmail;
  }
}
